import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Gift } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import api from "../lib/api";

export default function GiftPicker({ onPick }) {
  const [open, setOpen] = useState(false);
  const [gifts, setGifts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (open) { setLoading(true); api.get("/shop/inventory").then((r) => setGifts(r.data.gifts || [])).catch(() => {}).finally(() => setLoading(false)); }
  }, [open]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid="gift-picker-btn" className="p-2 rounded-full hover:bg-secondary text-penny">
          <Gift className="w-5 h-5" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-64 rounded-2xl" data-testid="gift-picker-panel">
        <p className="text-xs font-mono uppercase tracking-widest text-copper mb-2">Send a gift</p>
        {loading ? (
          <div className="text-center text-sm text-muted-foreground py-3">Loading…</div>
        ) : gifts.length === 0 ? (
          <div className="text-center text-sm text-muted-foreground py-3">
            No gifts yet.{" "}
            <Link to="/shop" className="text-copper font-medium" onClick={() => setOpen(false)}>Visit the Shop 💛</Link>
          </div>
        ) : (
          <div className="grid grid-cols-3 gap-2">
            {gifts.map((g) => (
              <button key={g.id} type="button" data-testid={`send-gift-${g.id}`} onClick={() => { onPick(g.id); setOpen(false); }}
                className="flex flex-col items-center p-2 rounded-xl hover:bg-secondary transition-colors">
                <span className="text-3xl">{g.emoji}</span>
                <span className="text-[10px] text-muted-foreground mt-0.5">×{g.count}</span>
              </button>
            ))}
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
}
